import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, ShieldAlert } from "lucide-react";

export default function Verify() {
  const { batch } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.get(`/verify/${batch}`).then(({ data }) => setResult(data)).catch(() => setResult({ authentic: false }));
  }, [batch]);

  return (
    <div className="px-4 sm:px-8 lg:px-12 pt-28 pb-20 max-w-2xl mx-auto min-h-[70vh] flex flex-col justify-center">
      <div className="mono-label mb-3 text-center">Scan to verify</div>
      <div className="glass-strong rounded-3xl p-8 sm:p-10 relative overflow-hidden text-center">
        <div className="scan-line" />
        {!result && <div className="text-slate-500 font-mono text-sm animate-pulse">Verifying batch {batch}…</div>}
        {result && (
          <>
            {result.authentic ? (
              <>
                <div className="w-16 h-16 mx-auto rounded-full bg-cyan-400/10 border border-cyan-400/40 flex items-center justify-center glow-cyan">
                  <ShieldCheck className="text-cyan-300" size={28} />
                </div>
                <h1 className="mt-5 font-mono text-xl tracking-[0.2em] text-cyan-300" data-testid="verify-authentic">AUTHENTIC CG LABZ PRODUCT</h1>
                <div className="mt-6 text-left space-y-2 font-mono text-xs">
                  {[["Batch", result.coa.batch], ["Peptide", result.coa.peptide_slug], ["SKU", result.coa.sku], ["Laboratory", result.coa.laboratory], ["Purity", `${result.coa.purity_pct}%`], ["Testing Date", result.coa.testing_date?.slice(0, 10)]].map(([k, v]) => (
                    <div key={k} className="flex justify-between border-b border-white/5 pb-2"><span className="text-slate-500 uppercase tracking-widest">{k}</span><span className="text-white">{v}</span></div>
                  ))}
                </div>
                {result.coa.demo && <p className="mt-4 text-[10px] font-mono text-violet-300 uppercase tracking-widest">Demo certificate — not a real lab result</p>}
              </>
            ) : (
              <>
                <div className="w-16 h-16 mx-auto rounded-full bg-rose-500/10 border border-rose-400/40 flex items-center justify-center">
                  <ShieldAlert className="text-rose-400" size={28} />
                </div>
                <h1 className="mt-5 font-mono text-xl tracking-[0.2em] text-rose-400" data-testid="verify-invalid">BATCH NOT FOUND</h1>
                <p className="mt-3 text-sm text-slate-400 font-mono">Batch <span className="text-white">{batch}</span> does not match any CG Labz record.</p>
              </>
            )}
          </>
        )}
        <Link to="/coa" className="mt-8 inline-block text-xs font-mono text-cyan-300">Open COA Library →</Link>
      </div>
    </div>
  );
}
